define.alias("shared/errors/fetch", "settings/errors/fetch");